import { useEffect, useState } from "react";

/** 3, 2, 1 — shown to everyone in the room (who has not muted it) before the cards turn. */
export function CountdownOverlay({ onComplete }: { onComplete: () => void }) {
  const [count, setCount] = useState(3);

  useEffect(() => {
    if (count === 0) {
      onComplete();
      return;
    }
    const timer = window.setTimeout(() => setCount(count - 1), 1000);
    return () => window.clearTimeout(timer);
  }, [count, onComplete]);

  if (count === 0) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm"
      role="status"
      aria-live="assertive"
      data-testid="countdown"
    >
      <div
        key={count}
        className="animate-in text-8xl font-bold text-primary duration-300 zoom-in-50 fade-in"
      >
        {count}
      </div>
    </div>
  );
}
